import ContactSalesNotice from '../../components/ContactSalesNotice';
import { selectProfile } from '../../../../../store/workspace/selectors';
import PriceSummary from '../../components/PriceSummary';
import { useDispatch, useSelector } from '../../../../../store/store';
import { InviteMemberIcon } from '../../../../../assets/icons';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { useState } from 'react';
import {
    setExtraServiceDetail,
    setAddExtraMemberModal,
    setExtraServicesPaymentModal,
} from '../../../../../store/workspace/slice';
import {
    MAX_MEMBER_SEATS,
    MEMBER_UNIT_PRICES,
    FALLBACK_PLAN_TYPE,
} from '../../constants';

export default function AddExtraMember() {
    const dispatch = useDispatch();
    const [count, setCount] = useState(0);
    const profile = useSelector(selectProfile);
    const unitPrice = MEMBER_UNIT_PRICES[profile?.planType || FALLBACK_PLAN_TYPE];
    /** Seats already owned by the plan count against the hard limit. */
    const purchasableSeats = MAX_MEMBER_SEATS - (profile?.memberCounter || 0);
    const reachedLimit = count === purchasableSeats;

    const closeModal = () => dispatch(setAddExtraMemberModal(false));

    const updateCount = (step: number) => {
        if (!profile || Number.isNaN(profile.memberCounter)) return;

        setCount(prev => Math.min(Math.max(prev + step, 0), MAX_MEMBER_SEATS - profile.memberCounter));
    };

    const submit = () => {
        dispatch(setExtraServiceDetail({
            type: 'member',
            sub: count,
        }));

        closeModal();
        dispatch(setExtraServicesPaymentModal(true));
    };

    return (
        <Modal
            size='md'
            actions='both'
            title='Add member seat'
            closeFunc={closeModal}
            icon={<InviteMemberIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'pay',
                type: 'Primary',
                onClick: submit,
                disabled: count === 0,
            }}
        >
            <h6>To add more, an additional member charge applies.</h6>

            <div className={styles.seat}>
                <div className={styles.seat_count}>
                    <b>{count}</b> Member account seat{count > 1 ? 's' : ''}
                </div>
                <div className={styles.seat_action}>
                    <div
                        className={styles.seat_action_btn}
                        onClick={() => updateCount(-1)}
                        data-is-deactive={count === 0}
                    >
                        <span>-</span>
                    </div>
                    <span>{count}</span>
                    <div
                        className={styles.seat_action_btn}
                        onClick={() => updateCount(1)}
                        data-is-deactive={reachedLimit}
                    >
                        <span>+</span>
                    </div>
                </div>
            </div>

            <PriceSummary
                breakdown={`$${unitPrice} per seat`}
                total={count * unitPrice}
            />

            {reachedLimit && <ContactSalesNotice
                text={`For more than ${MAX_MEMBER_SEATS} member seat you should contact sales!`}
            />}
        </Modal>
    );
};
